import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M15.6875 9.75C15.6875 7.72656 14.5938 5.86719 12.8438 4.82812C11.0664 3.81641 8.90625 3.81641 7.15625 4.82812C5.37891 5.86719 4.3125 7.72656 4.3125 9.75C4.3125 11.8008 5.37891 13.6602 7.15625 14.6992C8.90625 15.7109 11.0664 15.7109 12.8438 14.6992C14.5938 13.6602 15.6875 11.8008 15.6875 9.75ZM3 9.75C3 7.26172 4.3125 4.96484 6.5 3.70703C8.66016 2.44922 11.3125 2.44922 13.5 3.70703C15.6602 4.96484 17 7.26172 17 9.75C17 12.2656 15.6602 14.5625 13.5 15.8203C11.3125 17.0781 8.66016 17.0781 6.5 15.8203C4.3125 14.5625 3 12.2656 3 9.75ZM9.34375 6.03125C9.34375 5.67578 9.61719 5.375 10 5.375C10.3555 5.375 10.6562 5.67578 10.6562 6.03125L10.6563 9.42187L12.9805 10.9531C13.2813 11.1719 13.3633 11.582 13.1719 11.8828C12.9531 12.1836 12.543 12.2656 12.2422 12.0469L9.61719 10.2969C9.45313 10.1875 9.34375 9.96875 9.34375 9.75L9.34375 6.03125Z"
	})
});
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
